import {
  IconUser,
  IconBook,
  IconMoodKid,
  IconSettings,
  IconNotebook,
  IconAdjustments,
  IconLayoutDashboard,
  IconReportAnalytics,
} from '@tabler/icons-react';

import { EUserRole } from '@/enum';

export const sidebarMenu = [
  {
    id: 1,
    name: 'sidebar.dashboard',
    icon: IconLayoutDashboard,
    link: '/school/dashboard',
    disabled: false,
    allowedRoles: [EUserRole.SCHOOL, EUserRole.PARENT, EUserRole.TEACHER],
    roleLinks: {
      [EUserRole.SCHOOL]: '/school/dashboard',
      [EUserRole.PARENT]: '/parent/dashboard',
      [EUserRole.TEACHER]: '/teacher/dashboard',
    },
    hidden: false,
  },
  {
    id: 2,
    name: 'sidebar.report-analytics',
    icon: IconReportAnalytics,
    link: '/school/reports-analytics',
    disabled: false,
    allowedRoles: [EUserRole.SCHOOL, EUserRole.PARENT, EUserRole.TEACHER],
    roleLinks: {
      [EUserRole.SCHOOL]: '/school/reports-analytics',
      [EUserRole.PARENT]: '/parent/reports-analytics',
      [EUserRole.TEACHER]: '/teacher/reports-analytics',
    },
    hidden: false,
  },
  {
    id: 3,
    name: 'sidebar.controls',
    icon: IconAdjustments,
    link: '/school/controls',
    disabled: false,
    allowedRoles: [EUserRole.SCHOOL, EUserRole.PARENT],
    roleLinks: {
      [EUserRole.SCHOOL]: '/school/controls',
      [EUserRole.PARENT]: '/parent/controls',
    },
  },
  {
    id: 4,
    name: 'sidebar.teachers-classes',
    icon: IconUser,
    link: '/school/teachers-classes',
    disabled: false,
    allowedRoles: [EUserRole.SCHOOL],
  },
  {
    id: 5,
    name: 'sidebar.students',
    icon: IconMoodKid,
    link: '/school/students',
    disabled: false,
    allowedRoles: [EUserRole.SCHOOL],
  },
  {
    id: 6,
    name: 'sidebar.lessons',
    icon: IconBook,
    link: '/school/lessons',
    disabled: false,
    allowedRoles: [EUserRole.SCHOOL, EUserRole.TEACHER],
    roleLinks: {
      [EUserRole.SCHOOL]: '/school/lessons',
      [EUserRole.TEACHER]: '/teacher/lessons',
    },
    hidden: false,
  },
  {
    id: 7,
    name: 'sidebar.classes',
    icon: IconNotebook,
    link: '/teacher/classes',
    disabled: false,
    allowedRoles: [EUserRole.TEACHER],
  },
  {
    id: 8,
    name: 'sidebar.settings',
    icon: IconSettings,
    link: '/school/settings',
    disabled: false,
    roleLinks: {
      [EUserRole.SCHOOL]: '/school/settings',
      [EUserRole.PARENT]: '/parent/settings',
      [EUserRole.TEACHER]: '/teacher/settings',
    },
    allowedRoles: [EUserRole.SCHOOL, EUserRole.PARENT, EUserRole.TEACHER],
  },
];
